import React from 'react'
import image from 'D:/works/my-portfolio/src/jasmine.png' 
import { Link } from 'react-router-dom';
import { keyframes } from "styled-components";

const imagest =
{
      width: 300,
      height: 300,
}

const textst =
{
  fontFamily: "monospace",
  fontWeight: "bold",
  letterSpacing: 7,
  textAlign:"right", 
  color: "linear-gradient(to right, #ffffff 0, #b3f9ff 10%, #ffffff 20%, #cbf7fb 10%)",
}

export default function Opening(props) {
  return (
      <div className="intro">
      <div className="intro2">
      <img src={image} alt="My name came from this" className='flower' style={imagest}/>
      </div>
      <div className="intro3">
      <h1 className="name" style={textst}>HI!<br></br>MY NAME IS JESMINE</h1>
      <button className="btn btn-light"><Link className="navbar-brand" to="/home">GET TO KNOW ME</Link></button>
      
      </div>
      </div>
  )
}
